import React from "react";

const DateGreyIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5059_47627)">
        <path
          d="M8.97949 10.3984H9.72178V13.3676"
          stroke="#808080"
          strokeWidth="1.48458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6914 1.49219V4.46134"
          stroke="#808080"
          strokeWidth="1.48458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.04102 7.42188H16.4022"
          stroke="#808080"
          strokeWidth="1.48458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75293 1.49219V4.46134"
          stroke="#808080"
          strokeWidth="1.48458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9176 2.96875H4.52559C3.70568 2.96875 3.04102 3.63342 3.04102 4.45333V14.8454C3.04102 15.6653 3.70568 16.3299 4.52559 16.3299H14.9176C15.7375 16.3299 16.4022 15.6653 16.4022 14.8454V4.45333C16.4022 3.63342 15.7375 2.96875 14.9176 2.96875Z"
          stroke="#808080"
          strokeWidth="1.48458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5059_47627">
          <rect
            width="17.8149"
            height="17.8149"
            fill="white"
            transform="translate(0.814453)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DateGreyIcon;
